import type { Role } from '@/entities/user';

/**
 * In-store sale is an admin-dashboard screen.
 * Picker and packer tokens can call the same APIs; they do not get this route.
 */
export const offlineOrdersAccessRoles = ['admin'] as const satisfies readonly Role[];
